import BulkSendStatus from '@/enums/BulkSendStatus';
import BulkSendEntryStatus from '@/enums/BulkSendEntryStatus';
import EnvelopeState from '@/enums/EnvelopeState';

const NAME_SUFFIX = '::name';
const CONTACT_SUFFIX = '::contact';

export default {
  checkBulkSendIsDraft(bulkSend = {}) {
    const status = bulkSend?.status;
    const sent = bulkSend?.sent_start;
    return Boolean(
      status === BulkSendStatus.CREATED ||
        (BulkSendStatus.isBeforeSentStatus(status) && sent === null)
    );
  },
  getDisplayStatus(bulkSend = {}) {
    const status = bulkSend?.status;
    const total = bulkSend?.envelopes?.total;
    const completed = bulkSend?.envelopes?.completed;

    if (this.checkBulkSendIsDraft(bulkSend)) {
      return BulkSendStatus.DRAFT;
    }

    if (status !== BulkSendStatus.COMPLETED) {
      return status;
    }

    if (completed === 0) {
      return BulkSendStatus.DISPATCHED;
    }

    if (completed < total) {
      return BulkSendStatus.AWAITING_SIGNATURE;
    }

    return status;
  },
  getEntryDisplayStatus(entry = {}) {
    if (!entry?.envelope) {
      return entry?.status;
    }

    const envelopeStatuses = {
      [EnvelopeState.COMPLETED]: BulkSendEntryStatus.SIGNED,
      [EnvelopeState.CANCELLED]: BulkSendEntryStatus.CANCELLED,
      [EnvelopeState.EXPIRED]: BulkSendEntryStatus.EXPIRED,
      [EnvelopeState.HALTED]: BulkSendEntryStatus.HALTED,
    };

    return (
      envelopeStatuses[entry.envelope_state] ||
      BulkSendEntryStatus.AWAITING_SIGNATURE
    );
  },
  getRecipients(data) {
    // manual: [{ role, name, contact }]
    if (Array.isArray(data)) {
      return data.map((item) => ({
        prefix: item.role,
        name: item.name,
        contact: item.contact,
      }));
    }

    // csv: { 'role::name': '...', 'role::contact': '...' }
    return Object.keys(data || {})
      .filter((column) => column.endsWith(NAME_SUFFIX))
      .map((nameColumn) => {
        const prefix = nameColumn.replace(NAME_SUFFIX, '');
        return {
          prefix,
          name: data[nameColumn],
          contact: data[prefix + CONTACT_SUFFIX],
        };
      });
  },
};
